<!-- 协议列表 详情 -->
<template>
	<div id="bookingInformation">
		<el-row type="flex" justify="center" class="">
			<el-col :span="2" class="">
				<div class="butBox">
					<el-button :class="[!actStatus==true?'butBox-button-on':'butBox-button-off' ] " type="primary" @click="actStatus=false">演唱会</el-button>
				</div>
				<div class="butBox">
					<el-button :class="[ actStatus==true?'butBox-button-on':'butBox-button-off'] " type="primary" @click="actStatus=true">体育赛事</el-button>
				</div>
			</el-col>
			<el-col :span="22" class="BI-rightBox">
				<div class="BI-title">
					<p>凯迪拉克中心活动预定信息登记表</p>
					<p>CADILLAC ARENA EVENT BOOKING INFORMATION SHEET</p>
					<div class="BI-title-type"> {{ actStatus==true?'体育赛事':'演唱会' }} </div>
				</div>
				<h1>活动基本概况 Event Information</h1>
				<!-- 活动列表 详情 不可修改-->
				<el-form :model="formData" ref="formData" status-icon label-width="214px" label-lineHeight="24px" class="demo-ruleForm">
					<!-- 活动基本信息 -->
					<el-row type="flex" justify="center" class="">
						<el-col :span="12" class="">
							<el-form-item :label="'活动名称 \n Event Name'" class="elFormLabel">
								<el-input v-model="formData.eventName"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item :label="'活动场次 \n Quantity of the Event'">
								<el-input v-model="formData.eventQuantity"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="center" class="">
						<el-col :span="12" class="">
							<el-form-item :label="'活动日期 \n Date of the Event'">
								<el-date-picker v-model="formData.eventDate" type="datetime" placeholder="活动日期" value-format="yyyy-MM-dd HH:mm"
								 format="yyyy-MM-dd HH:mm">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item :label="'装台搭建日 \n Load in Days'">
						<!-- 		<el-date-picker v-model="formData.loadDays" type="datetime" placeholder="请输入装台搭建日" value-format="yyyy-MM-dd HH:mm"
								 format="yyyy-MM-dd HH:mm">
								</el-date-picker> -->
								<el-input v-model="formData.loadDays"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item label="三/四面台">
								<el-input v-model="formData.platform"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item :label="'其他特殊需求 \n Other Specific Requirements'">
						<el-input v-model="formData.otherRequirements" type="textarea"></el-input>
					</el-form-item>

					<!-- 主办方/承办方信息 -->
					<h1>主办方/承办方信息</h1>
					<el-row type="flex" justify="center" class="">
						<el-col :span="12" class="">
							<el-form-item :label="'主办方名称 \n Name of Promoter'">
								<el-input v-model="formData.promoterName" type="textarea"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item :label="'主办方所在地 \n Place of Promoter'">
								<el-input v-model="formData.promoterPlace" type="textarea"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="主办方近年主要活动">
						<el-input v-model="formData.promoterImpActivity" type="textarea"></el-input>
					</el-form-item>
					<el-form-item label="营业执照">
						<UploadImage @getImgUrl="getImgUrl" />
						<!-- <el-input v-model="formData.imageUrl" type="textarea"></el-input> -->
					</el-form-item>

					<el-row type="flex" justify="center" class="">
						<el-col :span="12" class="">
							<el-form-item :label="'承办方名称 \n Name of Organizer'">
								<el-input v-model="formData.organizerName" type="textarea"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item :label="'承办方所在地 \n Place of Organizer'">
								<el-input v-model="formData.organizerPlace" type="textarea"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<div v-if="!actStatus">
						<h1>演唱会 Concert Event Information</h1>
						<el-row type="flex" justify="center" class="">
							<el-col :span="12" class="">
								<el-form-item :label="'艺人姓名 \n  Name'">
									<el-input v-model="formData.artistName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12" class="">
								<el-form-item :label="'国籍 \n  Nationality'">
									<el-input v-model="formData.nationality"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<div v-if="actStatus">
						<h1>体育赛事活动信息</h1>
						<el-row type="flex" justify="center" class="">
							<el-col :span="12" class="">
								<el-form-item label="体育项目">
									<el-input v-model="formData.sportType"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12" class="">
								<el-form-item label="赛事级别">
									<el-input v-model="formData.competitionGrade"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="center" class="">
							<el-col :span="12" class="">
								<el-form-item label="明星运动员/队">
									<el-input v-model="formData.starPlayer"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12" class="">
								<el-form-item label="直播/录播渠道">
									<el-input v-model="formData.liveRecordedBroadcast"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>

					<el-row type="flex" justify="center" class="">
						<el-col :span="12" class="">
							<el-form-item :label="'最近三年演唱会/活动数量 \n Concerts/Events quantity in last three years'">
								<el-input v-model="formData.threeYearsCount"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="">
							<el-form-item :label="'社交媒体粉丝数量 \n Follower Quantity on Social Media'">
								<el-input v-model="formData.fansCount"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="最近三年演唱会平均人数/上座率">
						<el-input v-model="formData.threeYearsAverage"></el-input>
					</el-form-item>
					<el-form-item :label="'是否取消过演出或活动 \n Is there any concert/events canceled?'">
						<el-input v-model="formData.canceledHistory"></el-input>
					</el-form-item>
					<el-form-item label="取消原因" v-if="actStatus">
						<el-input v-model="formData.canceledReason"></el-input>
					</el-form-item>
					<!-- <el-row type="flex" justify="center" class="">
						<el-col :span="8" class="">
							
						</el-col>
						<el-col :span="16" class="">
							<el-form-item label="取消原因">
								<el-input v-model="formData.canceledReason"></el-input>
							</el-form-item>
						</el-col>
					</el-row> -->
					<el-row type="flex" justify="center" class="">
						<el-col :span="8" class="">
							<el-form-item :label="'联系人 \n Contact'">
								<el-input v-model="formData.contact"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8" class="">
							<el-form-item :label="'邮箱 \n Email'">
								<el-input v-model="formData.email"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8" class="">
							<el-form-item :label="'手机号 \n Mobile Number'">
								<el-input v-model="formData.mobile"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="其他意见或建议">
						<el-input v-model="formData.otherAdvice" type="textarea"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button class="butBox-button-on" type="primary" @click="submitForm()">保存提交</el-button>
					</el-form-item>

				</el-form>
			</el-col>
		</el-row>

	</div>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	import UploadImage from "@/components/UploadImage";
	export default {
		name: 'bookingInformation',
		components: {
			UploadImage,
		},
		props: {
			// 编辑的数据
			detailData: {
				type: Object,
				default: () => {}
			},
		},
		computed: {
			// formData() {
			// 	return this.detailData;
			// },
		},
		data() {
			return {
				actStatus: false, //false 演唱会 或者 true 体育赛事
				imageUrl: "", //图片地址 当清空 时 然后再重新 赋值
				formData: {
					"eventName": "", // 活动名称
					"eventDate": "", //   活动日期
					"eventQuantity": "", // 活动场次
					"platform": "", //三四面台
					"loadDays": "", // 装台搭建日
					"otherRequirements": "", // 其他特殊需求
					"promoterName": "", //主办方名称
					"promoterPlace": "", //主办方所在地
					"promoterImpActivity": "", //主办方近年来主要活动
					"imageUrl": "", //图片
					"organizerName": "", //承办方名称
					"organizerPlace": "", //承办方所在地
					"threeYearsCount": "", //近三年活动数量
					"threeYearsAverage": "", //进三年活动平均人数
					"canceledHistory": "", // 是否取消过
					"canceledReason": "", // 取消原因
					"fansCount": "", //社交媒体粉丝数量
					"contact": "", // 联系人
					"mobile": "", // 手机号
					"email": "", // 邮箱
					"otherAdvice": "", // 其他建议
					"eventType": "", // 1:演唱会 2：体育赛事
					//----演唱会----
					"artistName": "", // 艺人姓名
					"nationality": "", // 国籍
					//----体育赛事-----
					"sportType": "", //体育项目
					"competitionGrade": "", //赛事级别
					"starPlayer": "", // 明星运动员（队）
					"liveRecordedBroadcast": "", // 直播录播渠道
				}
			}
		},
		methods: {
			submitForm: function() {
				if (this.actStatus) {
					// true 体育赛事
					this.formData.eventType = 2;
				} else {
					// 演唱会
					this.formData.eventType = 1;
				};
				this.subAjax(this.formData);
			},
			subAjax: function(data) {
				const sendData = data;
				const sendUrl = this.httpUrl + "HXXCStadiumPCService/stadium/addStadiumEvent";
				const that = this;
				that.axiosPost(sendUrl, sendData).then((response) => {
					var backData = response.data;
					if (backData.state == 0) {
						that.$message({
							message: "操作成功",
							type: 'success',
							onClose: () => {
								that.$emit("subOver", true);
								let form = that.formData;
								Object.keys(form).forEach(key => (form[key] = ''));
								that.formData = form;
								that.formData.imageUrl = that.imageUrl;
							}
						});
					} else {
						that.$message({
							message: backData.message,
							type: 'warning'
						});
					}
				});
			},
			getImgUrl: function(val) {
				this.formData.imageUrl = val;
				this.imageUrl = val;
			}
		},
	}
</script>

<style scoped>
	#bookingInformation {
		padding: 14px 100px;
		height: 100%;
		background: url(../pic/img_bg3.jpg) no-repeat;
		background-size: 100%;
	}

	h1 {
		margin-bottom: 27px;
		font-size: 16px;
	}

	.butBox-button-off {
		width: 100px;
		margin-bottom: 10px;
		background: #fff;
		color: #090909;
		border: 1px solid #fff;
	}

	.butBox-button-on {
		width: 100px;
		margin-bottom: 10px;
		background: #B7A575;
		color: #fff;
		border: 1px solid #B7A575;
	}

	/* 多行label换行 */
	.el-form .el-form-item {
		white-space: pre-line;
	}

	.elFormLabel .el-form-item__label {
		line-height: 20px;
	}

	/deep/.el-form-item label {
		line-height: 20px;
	}

	.BI-title p {
		font-size: 16px;
		color: #B7A575;
	}

	.BI-rightBox {
		background: #fff;
		border: 1px solid #ccc;
		padding: 14px;
	}

	.BI-title-type {
		width: 110px;
		height: 30px;
		text-align: center;
		color: #fff;
		background: #B7A575;
		border-radius: 40px;
		line-height: 30px;
		margin-top: 15px;
		margin-bottom: 28px;
	}
</style>



// WEBPACK FOOTER //
// src/views/BookingInformation.vue